<!--<div id="wrapper">
    <topnavbar></topnavbar>-->
    <!--<app-navigation></app-navigation>-->
    <!--<div id="page-wrapper" class="d-flex flex-column">
        <div class="page-main">
            <router-outlet></router-outlet>
        </div>-->
        <!-- <footer></footer> -->
    <!--</div>
</div>-->
<!-- View/routes wrapper-->
<router-outlet></router-outlet>
